import { client } from "../../../api/client";

export const fetchUsers = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_userData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI,"usersapi/user");
      return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        return [];
    }
  }
};

export const fetchUsersByFilter = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_userData.json");
  } else {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"usersapi/user/filter", body);
      return response.data;
    } catch (error) {
        console.error("Error fetching users by filter:", error);
        return [];
    }
  }
};


export const fetchUserByGuid = async (guid) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_userData.json").filter(x => x.userGuid === guid);
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI,"usersapi/user/userguid/" + guid);
      return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        return;
    }
  }
};

export const updateUserRole = async (userId, roleId) => {
    try {
        return await client.put(process.env.REACT_APP_GATEWAY_URI,`usersapi/user/changeuserrole/${userId}/${roleId}`);
    } catch (error) {
        console.error("Error updating role:", error);
        return [];
    }    
};
